import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Injectable()
export class FormUtilService {
  public markAsTouchedDeep(control: AbstractControl): void {
    control.markAsTouched();
    if (control.hasOwnProperty('controls')) {
      const controls = (<FormGroup>control).controls;
      Object.keys(controls).forEach((key) => {
        this.markAsTouchedDeep(controls[key]);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/form-util.service.ts